import React, { useState, useEffect } from 'react';
import { getStore, setStore, connect } from "trim-redux";
import { Styles } from '../../../config/design/styles';
import validator from 'validator';
import axios from 'axios';
import { translate } from '../../../config/lang';
import HeaderTags from "../../components/elements/HeaderTags";
import { Box, TextField, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../components/elements/LoadingButton";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import PassField from "../../components/elements/fields/PassField";
import { defaultVariables } from "../../../config";
import { withStyles } from "@mui/styles";
import {useSnackbar} from "notistack";
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layout/components/AppCard";

const Register = (props) => {
    const navigation = useNavigate();
    const [fields, setFields] = useState({
        full_name: '',
        email: '',
        mobile: '',
        name: '',
        role: 'user',
        password: '',
        password_confirmation: ''
    });
    const { enqueueSnackbar } = useSnackbar();
    const [user_id, setUserId] = useState(props.user_id);
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [policyConfirmation, setPolicyConfirmation] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (getStore().isAuth) {
            handleLogout();
        }
    }, []);

    useEffect(() => {
        setUserId(props.user_id);
    }, [props.user_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFields = { ...fields };
        let newErrors = { ...errors };
        newErrors[name] = "";

        if (name === "name") {
            if (/^[a-z][a-z\d]*$/i.test(value)) {
                newFields[name] = value;
            }
        } else {
            newFields[name] = value;
        }

        setFields(newFields);
        setErrors(newErrors);
    };

    const handleLogout = () => {
        localStorage.removeItem('ACT');
        localStorage.removeItem('RET');
        setStore({
            isAuth: false,
            user: null,
        });
    };

    const handleValidation = async (callback) => {
        let newErrors = {};
        let formIsValid = true;

        // Full name
        if (validator.isEmpty(fields.full_name)) {
            formIsValid = false;
            newErrors['full_name'] = translate('emptyField');
        }
        // Name
        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            newErrors['name'] = translate('emptyField');
        }
        // Mobile
        if (!validator.isNumeric(fields.mobile) || fields.mobile.length !== 11) {
            formIsValid = false;
            newErrors['mobile'] = translate('wrongMobile');
        }
        // Email
        if (validator.isEmpty(fields.email)) {
            formIsValid = false;
            newErrors['email'] = translate('emptyEmail');
        } else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            newErrors['email'] = translate('wrongEmail');
        }
        // Password
        if (validator.isEmpty(fields.password)) {
            formIsValid = false;
            newErrors['password'] = translate('emptyPassword');
        } else if (fields.password.length < 4) {
            formIsValid = false;
            newErrors['password'] = translate('weakPassword');
        }
        // Password confirmation
        if (validator.isEmpty(fields.password_confirmation)) {
            formIsValid = false;
            newErrors['password_confirmation'] = translate('emptyField');
        } else if (fields.password_confirmation !== fields.password) {
            formIsValid = false;
            newErrors['password_confirmation'] = translate('noMatchPassword');
        }

        if(!!formIsValid){
            // Check email and mobile
            let data = new FormData();
            data.append('email', fields.email);
            data.append('mobile', fields.mobile);
            data.append('username', fields.name);

            const loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };

            try {
                const response = await axios.post(`${defaultVariables.url}/auth/check-info`, data, config);
                if (response.data.errors.mobile) {
                    formIsValid = false;
                    newErrors['mobile'] = response.data.errors.mobile[0];
                }
                if (response.data.errors.email) {
                    formIsValid = false;
                    newErrors['email'] = response.data.errors.email[0];
                }
                if (response.data.errors.name) {
                    formIsValid = false;
                    newErrors['name'] = response.data.errors.username[0];
                }
            } catch (error) {
                console.log(error);
            }
        }
        setErrors(newErrors);
        callback(formIsValid);
    };

    const handleRequest = async () => {
        const { full_name, email, mobile, password, password_confirmation, role, name } = fields;
        let data = new FormData();
        data.append('name', full_name);
        data.append('email', email);
        data.append('mobile', mobile);
        data.append('username', name);
        data.append('role', 'user');
        data.append('user_id', user_id);
        data.append('password', password);
        data.append('c_password', password_confirmation);
        data.append('avatar', "2");

        try {
            const response = await axios.post(`${defaultVariables.url}/auth/register`, data, {
                headers: { Accept: 'application/json' },
            });
            localStorage.setItem('ACT', response.data.accessToken);
        } catch (error) {
            console.log(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(translate('registerError'), {
                variant: 'error',
            });
        }

        const loginToken = localStorage.getItem('ACT');
        if (loginToken) {
            try {
                const response = await axios.get(`${defaultVariables.url}/auth/check-login`, {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`,
                    },
                });
                setStore({
                    isAuth: true,
                    user: response.data,
                });
                setSubmitLoading(false);
                setSuccess(true);
                navigation('/');
            } catch (error) {
                setStore({
                    isAuth: false,
                    user: null,
                });
                setSubmitLoading(false);
                enqueueSnackbar(translate('registerError'), {
                    variant: 'error',
                });
            }
        } else {
            setStore({
                isAuth: false,
                user: null,
            });
            setSubmitLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) {
                handleRequest();
            }else{
                setSubmitLoading(false);
            }
        });
    };

    const { classes, iframe } = props;

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={translate('register')}>
            <div className={classes.authContentInner}>
                <AppCard
                    title={ <h1>{translate('register')}</h1>}
                >
                    <form className={classes.form} noValidate onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    id="full_name"
                                    variant="outlined"
                                    label={translate('full_name')}
                                    placeholder={translate('full_name')}
                                    name="full_name"
                                    onChange={handleChange}
                                    autoFocus
                                    error={!!errors['full_name']}
                                    helperText={errors['full_name']}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    required
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    value={fields.name}
                                    label={translate('username')}
                                    placeholder={translate('usernameHint')}
                                    name="name"
                                    dir="ltr"
                                    onChange={handleChange}
                                    error={!!errors['name']}
                                    helperText={errors['name']}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    id="mobile"
                                    label={translate('mobile')}
                                    name="mobile"
                                    variant="outlined"
                                    dir="ltr"
                                    placeholder={translate('mobileSample')}
                                    onChange={handleChange}
                                    error={!!errors['mobile']}
                                    helperText={errors['mobile']}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    required
                                    size="small"
                                    fullWidth
                                    variant="outlined"
                                    id="email"
                                    label={translate('email')}
                                    name="email"
                                    dir="ltr"
                                    autoComplete="email"
                                    onChange={handleChange}
                                    error={!!errors['email']}
                                    helperText={errors['email']}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <PassField
                                    required
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="password"
                                    label={translate('password')}
                                    type="password"
                                    id="password"
                                    onChange={handleChange}
                                    error={!!errors['password']}
                                    helperText={errors['password']}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <PassField
                                    required
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="password_confirmation"
                                    label={translate('passwordConfirm')}
                                    placeholder={translate('passwordConfirm')}
                                    type="password"
                                    id="password_confirmation"
                                    onChange={handleChange}
                                    error={!!errors['password_confirmation']}
                                    helperText={errors['password_confirmation']}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <LoadingButton
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{ width: "100%" }}
                                styleForParent={{ marginBottom: 0 }}
                                loading={submitLoading}
                                success={success}
                            >
                                {translate('register')}
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 15 }}>
                            <Typography>
                                {translate('haveAccount')}{" "}
                                <Button size={"small"} component={Link} to={iframe ? "/iframe/login" : "/login"}>
                                    <strong>{translate('doLogin')}</strong>
                                </Button>
                            </Typography>
                        </Grid>
                    </form>
                </AppCard>
            </div>
        </AppAnimate>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,
});

export default withStyles(Styles)(connect(mstp)(Register));
